import { history } from "../_helpers";
export const dashboardServices = {
  getTopCardDashboard,
  getDailyJobRunTracker,
  getPieChartsDashboard,
  getDistinctConnections
};

function getTopCardDashboard() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/dashboard/topCards`,
    requestOptions
  ).then(handleResponse);
}

function getPieChartsDashboard() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/dashboard/pieCharts`,
    requestOptions
  ).then(handleResponse);
}

function getDailyJobRunTracker(limit, connectionId, jobRunStatus) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/dashboard/dailyJobRunTracker/${connectionId}/${limit}?jobRunStatus=${jobRunStatus}`,
    requestOptions
  ).then(handleResponse);
}

function getDistinctConnections() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/dashboard/distinctConnections`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
        //loc// location.reload(true);
      }
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        //redirecting to signin page
        history.push("/auth/signin");
        //removing local storage token
        localStorage.removeItem("user");
        return;
      }
      if (
        response.status === 403 &&
        data.message.includes("Resource Access not provided")
      ) {
        //redirecting to signin page
        setTimeout(() => {
          alert(
            "You don't have access to this resources. Please contact resource owner/admin to provide access"
          );
          history.push("/dashboard");
        }, 1000);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
